import { getEnv } from "@istari-frontend/shared";

export function formatInfosecLevelName(levelName: string): string {
  const isNotionalLabelEnabled = getEnv("VITE_INFOSEC_NOTIONAL_LABEL_ENABLED") === "true";
  return isNotionalLabelEnabled ? `NOTIONAL: ${levelName}` : levelName;
}
